export const MSGBADGE = 'MSGBADGE'
export const USERINFO = 'USERINFO'
export const H5CONFIG = 'H5CONFIG'
export const FACE = 'FACE'

export const keyModeType = 'MODETYPE'

export const announceType = {
  usual: 1, // 常规通告
  violate: 2, // 违规
  fault: 3, // 故障
  commend: 4, // 表扬
  welcome: 5, // 欢迎
  complaint: 6, // 投诉
  empty: 7, // 空占琴房，8
  positive: 8, // 积极练习奖励，
  negative: 9, // 消极练习处罚
  unLockDoor: 10, // 不关门签退
  adminAward: 11, // 表扬
  cancelBookByCourse: 13, // 安排课取消预约
  forceDown: 14, // 强制签退
  cancelBookAdmin: 15 // 管理员取消预约
}
export const announceTypes = {
  usual: {
    type: 1,
    url: 'systemMsg'
  },
  violate: {
    type: 2,
    url: 'punishNotice',
    apiUrl: 'violatPunisheQuery'
  },
  fault: {
    type: 3,
    url: 'failureReportMsg'
  },
  commend: 4, // 表扬
  welcome: 5, // 欢迎
  complaint: {
    type: 6,
    url: 'complaint'
  },
  empty: {
    type: 7,
    url: 'punishNotice',
    apiUrl: 'emptyPunishQuery'
  },
  positive: {
    type: 8,
    url: 'awardNotice'
  },
  negative: {
    type: 9,
    url: 'punishNotice',
    apiUrl: 'negativePunishQuery'
  },
  unLockDoor: {
    type: 10,
    url: 'punishNotice',
    apiUrl: 'unLockDoorPunishQuery'
  },
  adminAward: {
    type: 11,
    url: 'adminAward'
  },
  cancelBookByCourse: {
    type: 13,
    url: 'cancelBookByCourse'
  },
  forceDown: {
    type: 14,
    url: 'forceDown'
  },
  cancelBookAdmin: {
    type: 15,
    url: 'cancelBook'
  }
}

export const judgeClientType = {
  Android: 'Android',
  IOS: 'IOS',
  PC: 'PC'
}

export const unifiedEntryObj = {
  client_id: 'APPO12',
  response_uri: '/oauth2.0/authorize',

  // 回调地址
  redirect_uri: 'https://sxzx.tzc.edu.cn',
  client_secret: 'MfKoHBuUncjpHHz5CSmyhrxoN2vJHq7J1myLe07asPkazW8kApSWJHMzy4SIpu_0'
}
